import { PREDEFINED_TRIPLETS } from '../constants/predefined-triplet';
export function createTriplet() {
    return PREDEFINED_TRIPLETS[Math.floor(PREDEFINED_TRIPLETS.length * Math.random())];
}
